export default "__VITE_ASSET__BMxn2Po9__"